module.exports = __webpack_public_path__ + "static/media/vi.9af6bfa6.svg";